import React from "react";

const Loading: React.FC = () => {
  return (
    <div className="loading-wrapper">
      <span>·</span>
      <span>·</span>
      <span>·</span>
    </div>
  );
};

export default Loading;